<template >
  <div class="dzsflgl">
    <div style="background-color: white; width: 100%; display: flex; justify-content: space-between;">
      <div class="searchClass">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="书名:">
            <el-input v-model="searchForm.typeName" placeholder="输入分类名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadEbookTypeList">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="display: flex; flex-direction: row; align-items: center; margin-right: 20px">
        <el-button type="primary" style="width: 150px; height: 46px" round @click="handleAdd">添加内容</el-button>
      </div>
    </div>
    <div style="background-color: white">
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        >
        <el-table-column
          prop="typeName"
          label="分类名"
          width="200">
        </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          align="center" label="操作">
          <template slot-scope="scope" >
            <i class="el-icon-edit" style="color: blue"  @click="handleEdit(scope.row)"></i>
            <i class="el-icon-delete" style="color: red; margin-left: 15px"  @click="handleDelete(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>


    <div>
      <el-dialog title="信息详情" :visible.sync="dialogFormVisible">
        <el-form :model="updateForm" :rules="rules" ref="updateForm">
          <el-form-item label="分类名称" :label-width="formLabelWidth" prop="typeName">
            <el-input v-model="updateForm.typeName" autocomplete="off" placeholder="请输入分类名称"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>


</template>

<script>
import { qryEbookTypeList,updateEBookTypeInfo,delEBookTypeInfo} from '../../request/api';

export default {
  data() {
    return {
      checkAll: false,
      tableData: [],
      search: '',
      updateForm: {
        id:'',
        typeName: '',
        createDate: ''
      },
      rules: {
        typeName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' },
          { max: 50, message: '长度小于50个字符', trigger: 'blur' }
        ]
      },
      searchForm: {
        typeName: "",
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
    };
  },
  methods: {
    loadEbookTypeList(){
      let param = {
        typeName: this.searchForm.typeName
      }
      qryEbookTypeList(param).then(
        resp => {
          if (resp.code === 1) {
            // 渲染数据
            this.tableData = resp.data;
          } else {
            this.$message.error(resp.msg);
          }
        }
      ).catch(err => {
        console.log(err)
      })
    },

    handleAdd() {
      this.dialogFormVisible = true;
      this.updateForm.id=''
      this.updateForm.typeName=''
    },
    handleEdit(row) {
      this.dialogFormVisible = true;
      this.updateForm = row
    },
    handleDelete(row) {
      this.$confirm('确定删除选中记录吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let param = {
          id: row.id
        }
        delEBookTypeInfo(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // 渲染数据
              this.loadEbookTypeList();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onSubmit() {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false
          let param = this.updateForm;
          updateEBookTypeInfo(param).then(
            resp => {
              if (resp.code === 1) {
                this.$message.success(resp.msg);
                // 重置列表
                this.loadEbookTypeList();
              } else {
                this.$message.error(resp.msg);
              }
            }
          ).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted() {
    // 加载列表
    this.loadEbookTypeList();
  },
  props: ["itemData"]
};
</script>

<style lang="less">
.dzsflgl{
  background-color: #EFF3FF;
  padding: 20px;
  height: calc(100vh - 216px);
}
.el-table th.el-table__cell{
    background-color: #EFF3FF;
  }

  .searchClass{
    width: 900px;
    height: 70px;
    text-align: left;
    padding-left: 20px;
  }

.el-form-item__content {
  margin-top: 13px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
  .avatar-uploader{
    text-align: left;
  }
  .upload-demo{
    text-align: left;
  }
.dzsflgl .el-table .el-table__body-wrapper{
  height: calc(100vh - 455px);
  min-height: 250px;
  overflow-y: auto;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/dzs/dzsflgl.vue